/* global applyJayBar */

var html    = document.querySelector('html'),
    buttons = document.querySelectorAll('.button a'),
    pres    = document.querySelectorAll('pre');

html.classList.add('transitionable');

// HOMEPAGE

if (document.querySelector('body.page-home')) {
    getJsonp('https://jaysalvat.github.io/buzz/releases/latest/metadata.js', function (data) {
        buttons[0].textContent = buttons[0].textContent.replace('#version', data.version);
        buttons[0].dataset.date = data.date.replace(/ (.*)$/g, '') || '....-..-..';

        pres[0].textContent = pres[0].textContent.replace('https://cdnjs.com/libraries/buzz', 'https://cdnjs.cloudflare.com/ajax/libs/buzz/' + data.version + '/buzz.min.js');
    }, '__metadata');

    getJsonp('https://api.github.com/repos/jaysalvat/buzz/commits/master', function (data) {
        buttons[1].dataset.date = data.data.commit.committer.date.replace(/(T(.*))$/g, '') || '....-..-..';
    });

    if (typeof applyJayBar !== 'undefined') {
        applyJayBar(".topbar");
    }
}

// ADBLOCKERS

window.onload = function () {
    setTimeout(function () {
        if (!document.getElementById('carbonads_1')) {
            document.querySelector('.adblocked').style.display = 'block';
        }
    }, 2000)
};

// FUNCTIONS

function getJsonp (url, callback, callbackName) {
    if (!callbackName) {
        callbackName = 'FN' +  Math.floor(Math.random() * 1000000);
    }
    window[callbackName] = callback;

    var script = document.createElement('script');
    script.src = url + '?callback=' + callbackName;

    document.body.appendChild(script);
}

